import { defineStore } from "pinia";

export const permissions = defineStore("permissionStore", {
  state: () => {
    return {
      permissions: {
        comissao: ["list-all"],
      },
      roles: [],
      rolesSystem: ["admin", "colaborador"],
    };
  },

  actions: {
    setPermissions(data) {
      this.permissions = data.permissions;
      this.roles = data.roles;
    },
  },
  getters: {
    getState(state) {
      return {
        permissions: state.permissions,
        roles: state.roles,
        rolesSystem: state.rolesSystem,
      };
    },
    getRoles(state) {
      return state.roles;
    },
    getRolesSystem(state) {
      return state.rolesSystem;
    },
    getPermissions(state) {
      return state.permissions;
    },
  },
});
